import { jsx } from '@emotion/react';
import { daysFromNow } from '@zapier/date';
import { Alert, Link } from '@zapier/design-system';
import { UserInteractionEvent } from '../../../../universal-nav/utils/avroEvents';
export const shouldRender = (data) => {
    const { isTeamAccount, teamAccountEndDate } = data.currentAccount;
    return (!isTeamAccount &&
        !!teamAccountEndDate &&
        daysFromNow(teamAccountEndDate) <= 7);
};
export const Component = function TeamsDowngraded(props) {
    const onUpgrade = () => {
        props.trackEvent(UserInteractionEvent, {
            interaction_name: 'teams_downgraded_banner_cta_clicked',
            interaction_goal: 'upgrade_plan',
            event_action: 'click',
            option_selected: 'not_applicable',
        });
    };
    return (jsx(Alert, { variant: props.variant, title: "You\u2019ve recently canceled your Team plan", status: "info" },
        jsx(Link, { href: "/app/checkout/upgrade-to-team", onClick: () => onUpgrade() }, "Upgrade"),
        "\u00A0to regain your access to unlimited users, shared app connections, premier support, and more"));
};
//# sourceMappingURL=TeamsDowngraded.js.map
// @zapier/universal-layout@11.2.3 (b1a6e8603)
